import { gql } from '@apollo/client';
export const getCaseMetadataQuery = gql `
  query case($id: String!) {
    case(id: $id) {
      id
      customProperties
    }
  }
`;
